export const lerp = (start: number, end: number, t: number) => {
  return start + (end - start) * t;
};
